<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="$route.meta.navbarClasses ? $route.meta.navbarClasses : 'bg-success navbar-dark'"
    type=""
  >
          <el-select filterable
                     placeholder="Organisations"
                     v-model="$store.state.auth.user.organisation_id"
                     v-if="sortedOrganisations"
                     @change="changeOrganisation($event)">
            <el-option v-for="organisation in sortedOrganisations"
                       :key="organisation.name"
                       :label="organisation.name"
                       :value="organisation.id">
            </el-option>
          </el-select>
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> becouse they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler sidenav-toggler-dark"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
      <li class="nav-item d-sm-none">
        <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
      <base-dropdown v-if="false"
                     class="nav-item"
                     tag="li"
                     title-classes="nav-link"
                     title-tag="a"
                     icon="ni ni-bell-55"
                     menu-classes="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden">
        <template>
          <!-- Dropdown header -->
          <div class="px-3 py-3">
            <h6 class="text-sm text-muted m-0">You have <strong class="text-primary">13</strong> notifications.</h6>
          </div>
          <!-- List group -->
          <b-list-group flush>
            <b-list-group-item action href="#!">
              <b-row align-v="center" >
                <b-col md="auto">
                  <!-- Avatar -->
                  <b-img alt="Image placeholder" src="img/theme/team-1.jpg" class="avatar" rounded="circle" />
                </b-col>
                <b-col class="ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>2 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">Let's meet at Starbucks at 11:30. Wdyt?</p>
                </b-col>
              </b-row>
            </b-list-group-item>
            <a href="#!" class="list-group-item list-group-item-action">
              <b-row align-v="center">
                <b-col md="auto">
                  <!-- Avatar -->
                  <b-img alt="Image placeholder" src="img/theme/team-2.jpg" class="avatar" rounded="circle" />
                </b-col>
                <b-col class="ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>3 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">A new issue has been reported for Argon.</p>
                </b-col>
              </b-row>
            </a>
            <b-list-group-item action href="#!" >
              <b-row align-v="center">
                <b-col md="auto">
                  <!-- Avatar -->
                  <b-img alt="Image placeholder" src="img/theme/team-3.jpg" class="avatar" rounded="circle" />
                </b-col>
                <b-col class="ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>5 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">Your posts have been liked a lot.</p>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item action href="#!" >
              <b-row align-v="center">
                <b-col md="auto">
                  <!-- Avatar -->
                  <b-img alt="Image placeholder" src="img/theme/team-4.jpg" class="avatar" rounded="circle" />
                </b-col>
                <b-col class="ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>2 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">Let's meet at Starbucks at 11:30. Wdyt?</p>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item action href="#!" >
              <b-row align-v="center">
                <b-col md="auto">
                  <!-- Avatar -->
                  <b-img alt="Image placeholder" src="img/theme/team-5.jpg" class="avatar" rounded="circle" />
                </b-col>
                <b-col class="ml--2">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h4 class="mb-0 text-sm">John Snow</h4>
                    </div>
                    <div class="text-right text-muted">
                      <small>3 hrs ago</small>
                    </div>
                  </div>
                  <p class="text-sm mb-0">A new issue has been reported for Argon.</p>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
          <!-- View all -->
          <!-- This item dont have <b-dropdown-item> because item have styles " text-center text-primary font-weight-bold py-3" on tag <a> wich we cant add -->
          <a href="#!"  class="dropdown-item text-center text-primary font-weight-bold py-3">View all</a>
        </template>
      </base-dropdown>
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0"
                     v-if="loadUser"
                     >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
                  <span class="avatar avatar-sm rounded-circle">
                    <img alt="Image placeholder" src="img/theme/team-5.jpg">
                  </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm  font-weight-bold">{{ this.user.name }}</span>
            </b-media-body>
          </b-media>
        </a>

        <template>

          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </b-dropdown-header>
          <b-dropdown-item href="#!">
            <i class="ni ni-single-02"></i>
            <span>My profile</span>
          </b-dropdown-item>
          <b-dropdown-item href="#!">
            <i class="ni ni-settings-gear-65"></i>
            <span>Settings</span>
          </b-dropdown-item>
          <b-dropdown-item href="#!">
            <i class="ni ni-support-16"></i>
            <span>Support</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item href="#!" @click.native="crudApi.logout()">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item>

        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions';
  import { BaseNav, Modal } from '@/components';
  import crudApi from "../../crud/crud-api";
  import {Option, Select} from "element-ui";

  export default {
    components: {
      CollapseTransition,
      BaseNav,
      Modal,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    created() {
      this.loadOrganisations()

      this.$root.$refs.NavBar = this;
    },
    computed: {
      routeName() {
        const { name } = this.$route;
        return this.capitalizeFirstLetter(name);
      },
      isRTL() {
        return this.$rtl.isRTL;
      },
      loadUser() {
        crudApi.getUser(this.$store.state.auth.user.user_id).then(response => { this.user = response.data })
        return true
      }
    },
    data: _ => ({
      crudApi: crudApi,
      activeNotifications: false,
      showMenu: false,
      user: {},
      organisations: [],
      sortedOrganisations: undefined
    }),
    methods: {
      loadOrganisations() {
        crudApi.getOrganisations().then(response => { this.organisations = response.data; });
      },
      reloadOrganisations() {
        this.loadOrganisations()
      },
      changeOrganisation(event) {
        let organisationId = event
        this.$session.set('organisationId', organisationId);
        this.$store.state.filter.group = "ALL"
        this.$router.push({name: 'overview'}).catch(()=>{})
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      getOrganisation(organisationId, organisations) {
        for (let o of organisations) {
          if (o.id  === organisationId) {
            return o
          }
        }

        return undefined
      },
      getChildOrganisations(organisationId, organisations) {
        let results = []

        for (let o of organisations) {
          if (o.parentId && o.parentId === organisationId) {
            results.push(o)
          }
        }

        function compareStrings(a, b) {
          if (a < b) {
            return -1;
          }
          if (a > b) {
            return 1;
          }

          return 0;
        }

        results.sort((a, b) => compareStrings(a.name, b.name))

        return results
      },
      addChildOrganisations(organisationId, deep, childOrganisations, organisations) {
        let children = this.getChildOrganisations(organisationId, organisations)
        if (children) {
          for (let c of children) {
            let deepStr = ""
            for (let i = 0 ; i < deep ; i++) {
              deepStr += ">"
            }
            c.name = deepStr + " " + c.name

            childOrganisations.push(c)

            this.addChildOrganisations(c.id, deep+1, childOrganisations, organisations)
          }
        }
      }
    },
    watch: {
      organisations: function (newValue) {
        this.sortedOrganisations = []

        this.sortedOrganisations.push(this.getOrganisation(this.$store.state.auth.user.user_organisation_id, this.organisations))

        this.addChildOrganisations(this.$store.state.auth.user.user_organisation_id, 1, this.sortedOrganisations, this.organisations)
      }
    }
  };
</script>
<style scoped>
  .top-navbar {
    top: 0px;
  }
</style>
